import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=33838bb9&scoped=true&"
import script from "./Structure.vue?vue&type=script&lang=js&"
export * from "./Structure.vue?vue&type=script&lang=js&"
import style0 from "./Structure.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Structure.vue?vue&type=style&index=1&id=33838bb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33838bb9",
  null
  
)

export default component.exports